import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

const TEAL = "#06b6a4";

const TABLE_COLUMNS = [
  { key: "folio", label: "Folio", highlight: true },
  { key: "scheme", label: "Scheme" },
  { key: "sub_category", label: "Sub Category" },
  { key: "investor", label: "Investor" },
  { key: "long_term_value", label: "Long Term Value" },
  { key: "short_term_value", label: "Short Term Value" },
  { key: "add", label: "Add" },
  { key: "subtract", label: "Subtract" },
  { key: "load", label: "Load" },
];

const inputBorderStyle = { borderRadius: "8px", border: `1px solid ${TEAL}` };

export default function PortfolioRebalancing() {
  const [source, setSource] = useState("managed_data");
  const [investor, setInvestor] = useState("all_selected");
  const [newScheme, setNewScheme] = useState("");
  const [investorName, setInvestorName] = useState("");
  const [quantity, setQuantity] = useState("1");
  const [includeFactsheet, setIncludeFactsheet] = useState(false);
  const [applying, setApplying] = useState(false);

  const handleApply = () => {
    setApplying(true);
    setTimeout(() => setApplying(false), 600);
    // TODO: fetch rebalancing data
  };

  const handleAdd = () => {
    // TODO: add portfolio action
  };

  const handleRebalance = () => {
    // TODO: run rebalance
  };

  const handleExportXls = () => {
    // TODO: export Excel
  };

  const handleExportPdf = () => {
    // TODO: export PDF
  };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9", minHeight: "100vh" }}>
        {/* Header */}
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <h3 className="mb-2 text-primary">Portfolio Rebalancing</h3>
                <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <NavLink to="/overview">Dashboard</NavLink> /
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/reports/portfolio-rebalancing">Reports</NavLink> /
                    </li>
                    <li className="breadcrumb-item active">Portfolio Rebalancing</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>

        {/* Info banner */}
        <div
          className="d-flex align-items-start gap-2 p-3 mb-4 rounded"
          style={{ background: "#e0f2fe", color: "#0369a1", borderRadius: "12px", border: "1px solid #bae6fd" }}
        >
          <i className="fa fa-info-circle mt-1" style={{ fontSize: "1.1rem" }} aria-hidden />
          <span>
            Plan and preview portfolio changes (switches, purchases, or redemptions) to see how they'll impact your asset allocation and capital gains before you transact. This helps you maintain your portfolio's target asset allocation.
          </span>
        </div>

        {/* Filter bar */}
        <div className="card shadow-sm p-3 mb-4" style={{ borderRadius: "12px", border: "1px solid #e2e8f0" }}>
          <div className="d-flex flex-wrap align-items-end gap-3">
            <div>
              <label className="form-label small text-muted mb-1">Source :</label>
              <select
                className="form-select form-select-sm"
                value={source}
                onChange={(e) => setSource(e.target.value)}
                style={{ ...inputBorderStyle, width: "160px" }}
              >
                <option value="managed_data">Managed Data</option>
                <option value="all">All</option>
              </select>
            </div>
            <div>
              <label className="form-label small text-muted mb-1">Investor:</label>
              <select
                className="form-select form-select-sm"
                value={investor}
                onChange={(e) => setInvestor(e.target.value)}
                style={{ ...inputBorderStyle, width: "160px" }}
              >
                <option value="all_selected">All Selected</option>
                <option value="primary">Primary</option>
              </select>
            </div>
            <button
              type="button"
              className="btn px-4 py-2"
              style={{
                background: TEAL,
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                fontWeight: "600",
                fontSize: "14px",
              }}
              onClick={handleApply}
              disabled={applying}
            >
              {applying ? "Applying…" : "Apply"}
            </button>
          </div>
        </div>

        {/* Data table */}
        <div className="card shadow-sm mb-4" style={{ borderRadius: "12px", border: "1px solid #e2e8f0", overflow: "hidden" }}>
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead style={{ background: "#f8fafc" }}>
                <tr>
                  {TABLE_COLUMNS.map((col) => (
                    <th
                      key={col.key}
                      style={{
                        padding: "12px 16px",
                        color: col.highlight ? TEAL : "#64748b",
                        background: col.highlight ? "#ccfbf1" : undefined,
                        fontWeight: "600",
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {col.label}
                      <i className="fa fa-sort ms-1 opacity-75" style={{ fontSize: "10px" }} aria-hidden />
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={TABLE_COLUMNS.length} className="text-center py-5" style={{ color: "#94a3b8" }}>
                    <i className="fa fa-exclamation-triangle d-block mb-2" style={{ fontSize: "2rem" }} aria-hidden />
                    No data available.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Portfolio Action / Entry */}
        <div className="card shadow-sm p-4 mb-4" style={{ borderRadius: "12px", border: "1px solid #e2e8f0" }}>
          <div className="d-flex flex-wrap align-items-end gap-3">
            <div>
              <label className="form-label small text-muted mb-1">Select New Scheme</label>
              <div className="d-flex" style={{ border: `1px solid ${TEAL}`, borderRadius: "8px", overflow: "hidden" }}>
                <span className="d-flex align-items-center px-2 bg-white" style={{ color: "#64748b" }}>
                  <i className="fa fa-bars" aria-hidden />
                </span>
                <select
                  className="form-select form-select-sm border-0"
                  value={newScheme}
                  onChange={(e) => setNewScheme(e.target.value)}
                  style={{ minWidth: "200px", boxShadow: "none" }}
                >
                  <option value="">Select scheme…</option>
                </select>
              </div>
            </div>
            <div>
              <label className="form-label small text-muted mb-1">Select Investor name</label>
              <select
                className="form-select form-select-sm"
                value={investorName}
                onChange={(e) => setInvestorName(e.target.value)}
                style={{ ...inputBorderStyle, width: "180px" }}
              >
                <option value="">Select investor…</option>
              </select>
            </div>
            <div>
              <label className="form-label small text-muted mb-1">Quantity / Value</label>
              <input
                type="text"
                className="form-control form-control-sm"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                style={{ ...inputBorderStyle, width: "80px" }}
              />
            </div>
            <button
              type="button"
              className="btn px-4 py-2"
              style={{
                background: TEAL,
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                fontWeight: "600",
                fontSize: "14px",
              }}
              onClick={handleAdd}
            >
              Add
            </button>
          </div>
        </div>

        {/* Rebalance & Export */}
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
          <div className="d-flex justify-content-center flex-grow-1 order-2 order-md-1">
            <button
              type="button"
              className="btn px-5 py-2"
              style={{
                background: TEAL,
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                fontWeight: "600",
                fontSize: "15px",
              }}
              onClick={handleRebalance}
            >
              Rebalance
            </button>
          </div>
          <div className="d-flex align-items-center gap-3 order-1 order-md-2">
            <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={includeFactsheet}
                onChange={() => setIncludeFactsheet(!includeFactsheet)}
                style={{ accentColor: TEAL, width: 16, height: 16 }}
              />
              <span style={{ fontSize: "14px", color: "#475569" }}>Include Factsheet</span>
            </label>
            <button
              type="button"
              className="btn btn-sm border"
              onClick={handleExportXls}
              title="Export Excel"
              style={{ borderRadius: "8px" }}
            >
              <i className="fa fa-file-excel text-success" />
            </button>
            <button
              type="button"
              className="btn btn-sm border"
              onClick={handleExportPdf}
              title="Export PDF"
              style={{ borderRadius: "8px" }}
            >
              <i className="fa fa-file-pdf text-danger" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
